import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Switch,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  findCompOffLeaveType,
  isCompOffLeaveType,
} from "../compOffPolicy/utils/compOffLeaveType";
import { buildLeavePolicyPayload } from "./leavePolicyPayload";
import LeavePolicyComboPanel from "./LeavePolicyComboPanel";
import { extractLeavePolicyId } from "./leavePolicyComboMapper";
import {
  resetPolicy,
} from "../../redux/rtk/features/compOffPolicy/compOffPolicySlice";
import {
  leavePolicyComboGetById,
  leavePolicyComboSetup,
} from "../../redux/rtk/features/leavePolicy/leavePolicyComboApi";
import {
  addSingleLeavePolicy,
  addSingleLeaveType,
  getDefaultValidity,
  LeavePolicyGroupGetByCompanyId,
  LeavePolicyGroupSetup,
  loadAllLeavePolicy,
  loadAllLeaveType,
} from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const AddLeavePolicy = ({
  editRecord,
  clearEdit,
  onCompOffModeChange,
  openAsComboOff = false,
  selectedYear: tableSelectedYear = null,
}) => {
  const { list, loading } = useSelector((state) => state?.leavePolicy) || [];
  const masterData = useSelector((state) => state?.masters?.masters) || [];
  // console.log("masterdataa", masterData);
  
  const defaultValidity =
    useSelector((state) => state?.leavePolicy?.defaultValidity) || [];
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentLeavePolicyId, setCurrentLeavePolicyId] = useState(0);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [financialYears, setFinancialYears] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPolicyGroupModalVisible, setIsPolicyGroupModalVisible] =
    useState(false);
  const [newLeaveType, setNewLeaveType] = useState("");
  const [newPolicyGroupName, setNewPolicyGroupName] = useState("");
  const [creditType, setCreditType] = useState("");
  const [selectedYear, setSelectedYear] = useState(null);
  const dispatch = useDispatch();
  const leavePolicyGroup =
    useSelector((state) => state?.leavePolicy?.leavePolicyGroup) || [];
  const companyDetail = useSelector((state) => state?.setting?.list) || [];
  const compOffPolicy = useSelector((state) => state?.compOffPolicy?.policy);
  const selectedLeaveTypeId = Form.useWatch("leaveTypeId", form);

  const isCompOffLeave = useMemo(() => {
    const type = masterData?.LeaveTypeMaster?.find(
      (t) => String(t.LeaveTypeId) === String(selectedLeaveTypeId)
    );
    return isCompOffLeaveType(type?.LeaveTypeName);
  }, [selectedLeaveTypeId, masterData?.LeaveTypeMaster]);

  useEffect(() => {
    dispatch(getDefaultValidity());
    dispatch(LeavePolicyGroupGetByCompanyId());
  }, [dispatch]);

  useEffect(() => {
    if (tableSelectedYear) {
      setSelectedYear(tableSelectedYear);
      form.setFieldsValue({ YearId: tableSelectedYear });
    }
  }, [tableSelectedYear, form]);

 useEffect(() => {
    if (masterData && masterData.FinancialYearDetails && !tableSelectedYear) {
      setFinancialYears(masterData.FinancialYearDetails);

      let defaultYear;
      if (companyDetail?.IsLeaveCalenderYear) {
        defaultYear = masterData?.CalendarYearDetails.find((year) => year.IsCurrent)?.YearId;
      } else {
        defaultYear = masterData.FinancialYearDetails.find((year) => year.IsCurrent)?.YearId;
      }

      if (defaultYear) {
        setSelectedYear(defaultYear);
        // Set the form field value for YearId
        form.setFieldsValue({ YearId: defaultYear });
      }
    }
  }, [masterData, companyDetail, form]);

  // Function to get the current financial year ID
  const getCurrentFinancialYearId = (years) => {
    if (!years || years.length === 0) return null;

    const currentDate = new Date();

    // Find the financial year where current date falls between StartDate and EndDate
    const currentFinancialYear = years.find((year) => {
      const startDate = new Date(year.StartDate);
      const endDate = new Date(year.EndDate);
      return currentDate >= startDate && currentDate <= endDate;
    });

    return currentFinancialYear ? currentFinancialYear.YearId : null;
  };

  // Initialize the form with default values including financial year
  // useEffect(() => {
  //   // Only set the financial year if we're not in edit mode and have years available
  //   if (
  //     financialYears.length > 0 &&
  //     !isEditMode &&
  //     !form.getFieldValue("financialYearId")
  //   ) {
  //     const currentFinancialYearId = getCurrentFinancialYearId(financialYears);
  //     if (currentFinancialYearId) {
  //       // Directly set the field value without triggering UI updates
  //       form.setFieldsValue({
  //         financialYearId: currentFinancialYearId,
  //       });
  //     }
  //   }
  // }, [financialYears, isEditMode, form]);

  useEffect(() => {
    if (!editRecord) return;

    setIsEditMode(true);
    const leavePolicyId = editRecord.LeavePolicyId || editRecord.id;
    setCurrentLeavePolicyId(leavePolicyId);
    const creditValue = editRecord.credit === false ? "annually" : "monthly";
    setCreditType(creditValue);
    form.setFieldsValue({
      leaveTypeId: editRecord.LeaveTypeId || editRecord.leaveType?.id,
      LeavePolicyGroupId: parseInt(editRecord.LeavePolicyGroupId, 10) || editRecord.name,
      yearlyLimit: parseInt(editRecord.YearlyLimit, 10) || 0,
      monthlyLimit: parseInt(editRecord.MonthlyLimit, 10) || 0,
      unit: editRecord.InHours === true ? "hours" : "days",
      credit: creditValue,
      creditLimit:
        parseInt(editRecord.creditLimit || editRecord.LeaveCreditLimit, 10) ||
        0,
      paid: editRecord.IsPaidLeave || editRecord.paid || false,
      carryForward:
        editRecord.IsCarryForward || editRecord.carryForward || false,
      encashable: editRecord.IsEnCashable || editRecord.encashable || false,
      YearId: editRecord.YearId || selectedYear || tableSelectedYear,
    });

    if (isCompOffLeaveType(editRecord.LeaveTypeName) && leavePolicyId) {
      onCompOffModeChange?.(true);
      dispatch(leavePolicyComboGetById(leavePolicyId));
    }
  }, [editRecord, form, dispatch, onCompOffModeChange, selectedYear, tableSelectedYear]);

  useEffect(() => {
    if (onCompOffModeChange) {
      onCompOffModeChange(isCompOffLeave);
    }
  }, [isCompOffLeave, onCompOffModeChange]);

  useEffect(() => {
    if (!openAsComboOff || isEditMode || editRecord) return;
    if (!masterData?.LeaveTypeMaster?.length) return;

    const compOffType = findCompOffLeaveType(masterData.LeaveTypeMaster);
    if (!compOffType?.LeaveTypeId) {
      toast.warning(
        "Compensatory Off leave type not found. Add it in Leave Type master first."
      );
      return;
    }

    form.setFieldsValue({ leaveTypeId: compOffType.LeaveTypeId });
    onCompOffModeChange?.(true);
  }, [
    openAsComboOff,
    isEditMode,
    editRecord,
    masterData?.LeaveTypeMaster,
    form,
    onCompOffModeChange,
  ]);

  useEffect(() => {
    if (isCompOffLeave) {
      const leavePolicyId =
        editRecord?.LeavePolicyId || editRecord?.id || currentLeavePolicyId || null;

      if (!leavePolicyId) {
        dispatch(resetPolicy());
      }

      form.setFieldsValue({
        yearlyLimit: 0,
        monthlyLimit: 0,
        unit: "days",
        credit: "annually",
        creditLimit: 0,
        carryForward: false,
        encashable: false,
      });
      setCreditType("annually");
    }
  }, [isCompOffLeave, editRecord, currentLeavePolicyId, dispatch, form]);

  const resetForm = () => {
    form.resetFields();
    setIsEditMode(false);
    setCurrentLeavePolicyId(0);
    setCreditType("");
    clearEdit();

    // Set the current financial year when form is reset
    // if (financialYears.length > 0) {
    //   const currentFinancialYearId = getCurrentFinancialYearId(financialYears);
    //   if (currentFinancialYearId) {
    //     form.setFieldsValue({
    //       financialYearId: currentFinancialYearId,
    //     });
    //   }
    // }
  };

  const onFinish = async (values) => {
    setLoader(true);

    const payload = buildLeavePolicyPayload(values, {
      isCompOffLeave,
      leavePolicyId: currentLeavePolicyId,
      yearId: selectedYear || tableSelectedYear,
      masterData,
    });

    const resp = await dispatch(addSingleLeavePolicy(payload));

    if (resp.payload.message === "success") {
      const savedLeavePolicyId = extractLeavePolicyId(
        resp,
        currentLeavePolicyId,
        editRecord
      );

      if (isCompOffLeave && savedLeavePolicyId && compOffPolicy) {
        const comboResp = await dispatch(
          leavePolicyComboSetup({
            leavePolicyId: savedLeavePolicyId,
            policy: compOffPolicy,
          })
        );

        if (
          comboResp.meta.requestStatus === "rejected" ||
          comboResp.payload?.message === "error"
        ) {
          setLoader(false);
          toast.error(
            "Leave policy saved but combo-off configuration failed. Please edit and save again."
          );
          return;
        }
      }

      setLoader(false);
      resetForm();
      const reloadYear = values.YearId || selectedYear || tableSelectedYear;
      if (reloadYear) {
        dispatch(loadAllLeavePolicy(reloadYear));
      }
      toast.success(
        isEditMode
          ? "Leave policy updated successfully"
          : "Leave policy added successfully"
      );
    } else {
      setLoader(false);
      toast.error(
        isEditMode
          ? "Failed to update leave policy"
          : "Failed to add leave policy"
      );
    }
  };

  const onFinishFailed = () => {
    // toast.warning("Please fill all required fields correctly");
    setLoader(false);
  };

  const handleCreditChange = (e) => {
    setCreditType(e.target.value);
  };

 const handleYearChange = (yearId) => {
    setSelectedYear(yearId);
    form.setFieldsValue({ YearId: yearId }); // Sync form with selectedYear
  };

  const handleAddLeaveType = async () => {
    if (newLeaveType) {
      setLoader(true);
      const resp = await dispatch(
        addSingleLeaveType({
          leaveType: newLeaveType,
          defaultValidity: defaultValidity?.[0]?.id || 1,
        })
      );
      if (resp.payload.message === "success") {
        setLoader(false);
        setNewLeaveType("");
        setIsModalVisible(false);
        dispatch(loadAllLeaveType());
      } else {
        setLoader(false);
        toast.error("Failed to add leave type");
      }
    } else {
      toast.warning("Please enter a leave type!");
    }
  };

  const handleAddPolicyGroup = async () => {
    if (newPolicyGroupName) {
      setLoader(true);
      const payload = {
        LeavePolicyGroupId: 0,
        LeavePolicyGroupName: newPolicyGroupName,
        DataStatus: 1,
      };
      // Assuming LeavePolicyGroupSetup is an action similar to addSingleLeavePolicy
      const resp = await dispatch(LeavePolicyGroupSetup(payload));
      if (resp.payload.message === "success") {
        setLoader(false);
        setNewPolicyGroupName("");
        setIsPolicyGroupModalVisible(false);
        dispatch(LeavePolicyGroupGetByCompanyId());
        toast.success("Leave policy group added successfully");
      } else {
        setLoader(false);
        toast.error("Failed to add leave policy group");
      }
    } else {
      toast.warning("Please enter a leave policy group name!");
    }
  };

  return (
    <>
      <Modal
        title="Add Leave Type"
        visible={isModalVisible}
        onOk={handleAddLeaveType}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={loader}
      >
        <Input
          placeholder="Enter leave type"
          value={newLeaveType}
          onChange={(e) => setNewLeaveType(e.target.value)}
        />
      </Modal>
      <Modal
        title="Add Leave Policy Group"
        visible={isPolicyGroupModalVisible}
        onOk={handleAddPolicyGroup}
        onCancel={() => setIsPolicyGroupModalVisible(false)}
        confirmLoading={loader}
      >
        <Input
          placeholder="Enter leave policy group name"
          value={newPolicyGroupName}
          onChange={(e) => setNewPolicyGroupName(e.target.value)}
        />
      </Modal>
      <Form
        form={form}
        layout="vertical"
        className="leave-policy-modal-form"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          isNational: true,
          isRestricted: false,
          selectedYear:selectedYear
        }}
      >
        <div className="leave-policy-modal-scroll">
        <Row
          gutter={16}
          className={`leave-policy-split-row${isCompOffLeave ? " leave-policy-split-row--combo" : ""}`}
        >
          <Col
            xs={24}
            lg={isCompOffLeave ? 9 : 24}
            className="leave-policy-split-left"
          >
            <Form.Item
              name="YearId"
                    label={
                  companyDetail?.IsLeaveCalenderYear
                    ? "Select Year"
                    : "Select Financial Year"
                }
              rules={[
                { required: true, message: "Please select an year!" },
              ]}
            >
              <Select
                style={{ width: 180, marginRight: 10 }}
                placeholder={
                  companyDetail?.IsLeaveCalenderYear
                    ? "Select Year"
                    : "Select Financial Year"
                }
                value={selectedYear}
                onChange={handleYearChange}
              >
                {companyDetail?.IsLeaveCalenderYear
                  ? masterData?.CalendarYearDetails?.map((year) => (
                      <Option key={year.YearId} value={year.YearId}>
                        {year.YearName}
                      </Option>
                    ))
                  : // <Option
                    //   key={masterData?.CalendarYearDetails?.YearId}
                    //   value={masterData?.CalendarYearDetails?.YearId}
                    // >
                    //   {masterData?.CalendarYearDetails?.YearName}
                    // </Option>
                    financialYears.map((year) => (
                      <Option key={year.YearId} value={year.YearId}>
                        {year.YearName}
                      </Option>
                    ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Leave Policy Name"
              required
              validateStatus={
                form.getFieldError("LeavePolicyGroupId").length ? "error" : ""
              }
              help={form.getFieldError("LeavePolicyGroupId").join(", ")}
            >
              <div style={{ display: "flex", gap: "8px" }}>
                <Form.Item
                  name="LeavePolicyGroupId"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "Please enter the leave policy name!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select leave Policy"
                    loading={loading}
                    style={{ flex: 1 }}
                    allowClear
                  >
                    
                    {leavePolicyGroup?.map((type) => (
                      <Select.Option
                        key={parseInt(type.LeavePolicyGroupId)}
                        value={parseInt(type.LeavePolicyGroupId)}
                      >
                        {type.LeavePolicyGroupName} 
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => setIsPolicyGroupModalVisible(true)}
                />
              </div>
            </Form.Item>

            <Form.Item
              name="leaveTypeId"
              label="Leave Type"
              rules={[
                { required: true, message: "Please select a leave type!" },
              ]}
            >
              <Select placeholder="Select leave type" loading={loading}>
                {masterData.LeaveTypeMaster?.map((type) => (
                  <Option key={type.LeaveTypeId} value={type.LeaveTypeId}>
                    {type.LeaveTypeName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {isCompOffLeave && (
              <Form.Item name="paid" label="Is Paid Leave" valuePropName="checked">
                <Switch />
              </Form.Item>
            )}
          </Col>

          {isCompOffLeave && (
            <Col xs={24} lg={15} className="leave-policy-split-right">
              <LeavePolicyComboPanel />
            </Col>
          )}
        </Row>

        {!isCompOffLeave && (
        <>
        <Form.Item
          name="yearlyLimit"
          label="Max Leaves Per Year"
          rules={[
            { required: true, message: "Please enter the yearly leave limit!" },
          ]}
        >
          <InputNumber
            min={0}
            placeholder="Enter number of days"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          name="monthlyLimit"
          label="Max Leaves Per Month"
          rules={[
            {
              required: true,
              message: "Please enter the monthly leave limit!",
            },
          ]}
        >
          <InputNumber
            min={0}
            placeholder="Enter number of days"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          name="unit"
          label="Unit"
          rules={[{ required: true, message: "Please select a unit!" }]}
        >
          <Radio.Group>
            <Radio value="days">Days</Radio>
            <Radio value="hours">Hours</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="credit"
          label="Credit"
          rules={[{ required: true, message: "Please select a credit type!" }]}
        >
          <Radio.Group onChange={handleCreditChange}>
            <Radio value="annually">Annually</Radio>
            <Radio value="monthly">Monthly</Radio>
          </Radio.Group>
        </Form.Item>

        {creditType && (
          <Form.Item
            name="creditLimit"
            label={
              creditType === "monthly"
                ? "Monthly Credit Value"
                : "Annual Credit Value"
            }
            rules={[
              {
                required: true,
                message: `Please enter the ${creditType} credit value!`,
              },
            ]}
          >
            <InputNumber
              min={0}
              placeholder={`Enter number of ${
                creditType === "monthly" ? "days per month" : "days per year"
              }`}
              style={{ width: "100%" }}
            />
          </Form.Item>
        )}

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="paid"
              label="Is Paid Leave"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="carryForward"
              label="Allow Carry Forward"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="encashable"
              label="Encashable"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        </>
        )}

        </div>

        <div className="leave-policy-modal-footer">
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" htmlType="submit" loading={loader}>
                {isEditMode ? "Update Policy" : "Save Policy"}
              </Button>
              {isEditMode && <Button onClick={resetForm}>Cancel</Button>}
            </Space>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default AddLeavePolicy;
